module.exports = __webpack_public_path__ + "static/media/ico-fontInter.72516470.svg";